import Vue from "vue";
import Cloud from "./cloud-vue";
import App from './App.vue'
import element from "./plugins/element";
import router from "@/routers";
import CSS from "@/utils/css";
Vue.prototype.$CSS = CSS;

new Cloud({
    router,
    element,
    debug: false,
    render: h => h(App),
})
